export const isSmallViewport = () => window.matchMedia('(max-width: 991px)').matches;
export const isDesktopViewport = () => window.matchMedia('(min-width: 1024px)').matches;
